import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ICON } from '@core/util/icon';
import { NavigationService } from '@services/nav/nav.service';

@Component({
	selector: 'app-contact',
	templateUrl: './contact.component.html',
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false,
})
export class ContactComponent {
	ICON = ICON;
	supportEmail = 'support@lawlabs.ca';
	supportPhone = '1-888-520-4004';

	constructor(private navigationService: NavigationService) {}

	goToLogin(): void {
		this.navigationService.goToLogin();
	}
}
